const isNewEntity = (entity) => {
    const currentDateTimestamp = new Date().getTime();
    const createdDatePlusOneDay =
        new Date(entity.createdDateTime).getTime() + 24 * 60 * 60 * 1000;

    return currentDateTimestamp < createdDatePlusOneDay;
};

export default isNewEntity;
